export function initProductFilter() {
    const $catLinks = $('.catlink');
    const $products = $('#product-list article');

    function filterProducts(selectedCategory, $clickedLink = null) {
        $products.each(function() {
            const $product = $(this);
            if ($product.data('category') === selectedCategory) {
                $product.show();
            } else {
                $product.hide();
            }
        });

        // Reset all backgrounds and update the selected one
        $('.subcategory-item .background').height(0);
        
        if ($clickedLink) {
            $clickedLink.closest('.subcategory-item').find('.background').height('100%');
        }
    }

    $catLinks.on('click', function(e) {
        e.preventDefault();
        const selectedCategory = $(this).data('type');
        filterProducts(selectedCategory, $(this));
    });

    // Select first category on page load
    if ($catLinks.length > 0) {
        const $firstLink = $catLinks.first();
        filterProducts($firstLink.data('type'), $firstLink);
    }
}
